// AUTO-GENERATED FILE — DO NOT EDIT. Run `bazel run settings-registry`.
//
// Regenerate with `bazel run settings-registry`.

import type { SettingsWrapperManifest } from "./settings-wrapper-manifest.types";

export const settingsWrapperManifest: SettingsWrapperManifest = {
  sections: [
    { id: "commentsold-coverage", file: "coverage/coverage.tsx" },
    { id: "coverage.advanced_coverage", file: "coverage/coverage.tsx" },
    {
      id: "coverage.checkout_ui_customizations",
      file: "coverage/coverage.tsx",
    },
    { id: "coverage.custom_logo", file: "coverage/custom-logo.tsx" },
    { id: "coverage.display_options", file: "coverage/coverage.tsx" },
    { id: "coverage.exclusions", file: "coverage/coverage.tsx" },
    { id: "coverage.general_coverage", file: "coverage/coverage.tsx" },
    { id: "coverage.info_modal", file: "coverage/info-modal.tsx" },
    { id: "coverage.pre_protected_orders", file: "coverage/coverage.tsx" },
    { id: "coverage.return_coverage", file: "coverage/coverage.tsx" },
    {
      id: "customer_accounts_ad_blocks_edit.ad_blocks_edit",
      file: "customer-accounts/ad-blocks/ad-blocks-builder.tsx",
    },
    {
      id: "customer_accounts_ad_blocks.ad_blocks",
      file: "customer-accounts/ad-blocks/ad-blocks-drawer.tsx",
    },
    {
      id: "customer_accounts_storefront_display.native_accounts",
      file: "customer-accounts/storefront-displays.tsx",
    },
    {
      id: "customer_accounts_storefront_display.save_for_later",
      file: "customer-accounts/storefront-displays.tsx",
    },
    {
      id: "customer_portal_ab_test_analytics.overview",
      file: "return-flow/ab-test-analytics.tsx",
    },
    { id: "customer_portal_bundles.overview", file: "bundles/bundles.tsx" },
    {
      id: "customer_portal_flow_editors.overview",
      file: "flows/generic-flow-editor.tsx",
    },
    {
      id: "customer_portal.ai_exchange_agent",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.bundles",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.customize",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.discount_distribution",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.exchange_settings",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.flows",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.localization",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_portal.predefined_categories",
      file: "customer-portal/customer-portal-page.tsx",
    },
    {
      id: "customer_widget.appearance",
      file: "customer-widget/tabs/general-tab.tsx",
    },
    {
      id: "customer_widget.setup",
      file: "customer-widget/tabs/general-tab.tsx",
    },
    { id: "display", file: "coverage/coverage.tsx" },
    { id: "dynamic-coverage-transform", file: "coverage/coverage.tsx" },
    {
      id: "exchange_agent_guidance.overview",
      file: "exchange-agent-guidance/exchange-agent-guidance-page.tsx",
    },
    {
      id: "fulfillment.import_restrictions",
      file: "restrictions/restrictions-page.tsx",
    },
    { id: "fulfillment.printing", file: "printing.tsx" },
    {
      id: "fulfillment.scan_to_verify",
      file: "scan-to-verify-settings-drawer.tsx",
    },
    { id: "fulfillment.ship_from_locations", file: "general.tsx" },
    { id: "hsa.buy_buttons", file: "conversion/hsa/hsa-settings-page.tsx" },
    {
      id: "international_customs.customs_artifact",
      file: "customs/customs-page.tsx",
    },
    {
      id: "international_customs.customs_metafields",
      file: "customs/customs-page.tsx",
    },
    {
      id: "international_markets_editor.market_editor",
      file: "markets/market-editor-page.tsx",
    },
    { id: "international_markets.markets", file: "markets/markets-page.tsx" },
    {
      id: "international_returns.customs_csv_import",
      file: "international/import-international-customs-csv-card.tsx",
    },
    {
      id: "international_returns.customs_delay_notifications",
      file: "international/customs-delay-notification-section.tsx",
    },
    {
      id: "international_returns.customs_metafields",
      file: "international/international-sections.tsx",
    },
    {
      id: "international_returns.redo_assisted_customs",
      file: "international/redo-assisted-customs-card.tsx",
    },
    {
      id: "international_returns.tax_ids",
      file: "international/international-sections.tsx",
    },
    {
      id: "inventory_general.adjustment_reasons",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_general.cycle_count_variance",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_general.reserved_inventory_buckets",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "inventory_purchase_orders.purchase_orders",
      file: "inventory-management/purchase-order-settings.tsx",
    },
    {
      id: "inventory_purchase_orders.recommendation_urgencies",
      file: "inventory-management/purchase-order-settings.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.account_mapping",
      file: "inventory-management/quickbooks-account-mapping.tsx",
    },
    {
      id: "inventory_quickbooks_account_mapping.location_mapping",
      file: "inventory-management/quickbooks-account-mapping.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_connection",
      file: "inventory-management/quickbooks-integration-settings.tsx",
    },
    {
      id: "inventory_quickbooks.quickbooks_sync_settings",
      file: "inventory-management/quickbooks-integration-settings.tsx",
    },
    {
      id: "order_tracking_settings.carrier_mappings",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "order_tracking_settings.general",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "order_tracking_settings.weekly_email",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "portal_builder.overview",
      file: "customer-portal-builder/customer-portal-builder-settings.tsx",
    },
    {
      id: "products_attributes_by_owner.attribute_definitions_by_owner",
      file: "attribute-definitions/attribute-definitions-page.tsx",
    },
    {
      id: "products_attributes.attribute_definitions",
      file: "attribute-definitions/attribute-definitions-landing-page.tsx",
    },
    { id: "products_general.hazmat", file: "product/product.tsx" },
    { id: "redo-item-fulfillment", file: "coverage/coverage.tsx" },
    {
      id: "returns_billing_general.subscription",
      file: "billing/products/returns/returns-billing.tsx",
    },
    {
      id: "returns.advanced_processing",
      file: "automation/processing/advanced-processing-flows-section.tsx",
    },
    {
      id: "returns.automation_agent_review",
      file: "automation/agent-review-card.tsx",
    },
    {
      id: "returns.automation_claim_processing",
      file: "automation/processing/claim-processing-section.tsx",
    },
    {
      id: "returns.automation_dropoff_processing",
      file: "automation/processing/dropoff-auto-processing-section.tsx",
    },
    {
      id: "returns.automation_general",
      file: "automation/general-settings-card.tsx",
    },
    {
      id: "returns.automation_green_returns",
      file: "automation/processing/green-returns-section.tsx",
    },
    {
      id: "returns.automation_inventory",
      file: "automation/inventory-card.tsx",
    },
    {
      id: "returns.automation_label_expiration",
      file: "automation/label-expiration-card.tsx",
    },
    {
      id: "returns.automation_merchant_created",
      file: "automation/inventory-card.tsx",
    },
    {
      id: "returns.automation_return_processing",
      file: "automation/processing/return-processing-section.tsx",
    },
    {
      id: "returns.automation_shopify",
      file: "automation/shopify-settings-card.tsx",
    },
    {
      id: "returns.exchanges_fulfillment",
      file: "exchanges/cards/fulfillment-card.tsx",
    },
    {
      id: "returns.exchanges_fulfillment_regions",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
    },
    {
      id: "returns.exchanges_order_notes",
      file: "exchanges/cards/exchange-notes-card.tsx",
    },
    {
      id: "returns.exchanges_order_pricing",
      file: "exchange/exchange-financial-strategy-section.tsx",
    },
    { id: "returns.exchanges_orders", file: "exchanges/cards/order-card.tsx" },
    {
      id: "returns.exchanges_shipping_name",
      file: "exchanges/cards/exchange-shipping-card.tsx",
    },
    { id: "returns.permissions", file: "permissions/permissions.tsx" },
    { id: "returns.pos", file: "point-of-sale/general-section.tsx" },
    {
      id: "returns.pos_integration_locations",
      file: "point-of-sale/integration-locations-page.tsx",
    },
    { id: "returns.processing", file: "processing.tsx" },
    {
      id: "returns.shipping_dropoff_providers",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_label_combination",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_options",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.shipping_return_locations",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.ui_barcodes",
      file: "shipping/sections/shipping-settings-sections.tsx",
    },
    {
      id: "returns.ui_external_ra_number",
      file: "returns-ui/external-ra-number-card.tsx",
    },
    {
      id: "returns.ui_gift_receipts",
      file: "returns-ui/gift-receipts-card.tsx",
    },
    {
      id: "returns.ui_item_disposition",
      file: "returns-ui/item-disposition-card.tsx",
    },
    {
      id: "returns.ui_return_details",
      file: "returns-ui/return-details-card.tsx",
    },
    {
      id: "returns.ui_return_editing",
      file: "returns-ui/return-editing-card.tsx",
    },
    {
      id: "returns.warehouse_grade_actions",
      file: "managed-returns/returns-centers-index.tsx",
    },
    {
      id: "returns.withdrawals_auto_cancellation",
      file: "withdrawals/withdrawals-settings.tsx",
    },
    {
      id: "returns.withdrawals_exclusions",
      file: "withdrawals/withdrawals-settings.tsx",
    },
    {
      id: "returns.withdrawals_general",
      file: "withdrawals/withdrawals-settings.tsx",
    },
    {
      id: "returns.withdrawals_notifications",
      file: "withdrawals/withdrawals-settings.tsx",
    },
    { id: "sales-channels", file: "coverage/coverage.tsx" },
    {
      id: "shipping_carriers.carriers",
      file: "carrier-accounts/carriers-page.tsx",
    },
    { id: "shipping_cross_border.cross_border", file: "cross-border.tsx" },
    { id: "shipping_discounts.free_shipping_codes", file: "discounts.tsx" },
    {
      id: "shipping_freight.freight_delivery_accessorials",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_handling_units",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_pickup_accessorials",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_freight.freight_pickup_windows",
      file: "freight/freight-page.tsx",
    },
    {
      id: "shipping_fulfillment_promise.fulfillment_cutoff",
      file: "fulfillment-cutoff/fulfillment-cutoff-page.tsx",
    },
    { id: "shopify-cart-validation", file: "coverage/coverage.tsx" },
    {
      id: "support.csat",
      file: "customer-satisfaction/csat-settings-shell.tsx",
    },
    {
      id: "support.live_chat_widget",
      file: "customer-widget/tabs/support-tab.tsx",
    },
    { id: "support.ticket_routing", file: "general.tsx" },
    {
      id: "warranty_registration_rewards.discount",
      file: "registration-rewards.tsx",
    },
    {
      id: "warranty_registration.purchase_channels",
      file: "registration-settings.tsx",
    },
    {
      id: "warranty_registration.registration_collections",
      file: "registration-settings.tsx",
    },
  ],
  settings: [
    {
      id: "bulkReturnsEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "cart-validation-function",
      file: "coverage/coverage.tsx",
      sectionId: "shopify-cart-validation",
    },
    { id: "channel-selector", file: "coverage/sales-channels-card.tsx" },
    { id: "checkboxFontSize", file: "coverage/coverage.tsx" },
    { id: "checkboxSelector", file: "coverage/coverage.tsx" },
    {
      id: "checkoutOptimization/fulfillmentCutoffSchedule",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.tsx",
    },
    { id: "checkoutSelector", file: "customer-portal/exchange-settings.tsx" },
    { id: "color", file: "coverage/coverage.tsx" },
    { id: "coverage", file: "coverage/coverage.tsx" },
    {
      id: "coverage-builder",
      file: "coverage/coverage.tsx",
      sectionId: "display",
    },
    { id: "coverageExcludeCentEnding", file: "coverage/coverage.tsx" },
    { id: "coverageExcludeCollections", file: "coverage/coverage.tsx" },
    {
      id: "coverageExcludeCustomerTags",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeDiscountCodes",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    { id: "coverageExcludeProductTags", file: "coverage/coverage.tsx" },
    {
      id: "coverageExcludeProperties",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeSources",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "coverageExcludeTags",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    { id: "custom-logo", file: "coverage/coverage.tsx", sectionId: "display" },
    {
      id: "customerAccounts/nativeAccounts/overrideAccountLinks",
      file: "customer-accounts/native-accounts.tsx",
    },
    {
      id: "customerAccounts/nativeAccounts/redirectFromAccountsPages",
      file: "customer-accounts/native-accounts.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/anchorLocation",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/enabled",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/message",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/numViewedProductsUntilPanelOpen",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerAccounts/saveForLaterPanel/title",
      file: "customer-accounts/save-for-later-storefront-display.tsx",
    },
    {
      id: "customerWidget/general/hideWidgetAfterHours",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customerWidget/general/showCustomerWidgetInReturnApp",
      file: "customer-widget/tabs/general-tab.tsx",
      sectionId: "customer_widget.setup",
    },
    {
      id: "customerWidget/general/widgetColor",
      file: "customer-widget/tabs/general-tab.tsx",
      sectionId: "customer_widget.appearance",
    },
    {
      id: "customerWidget/support/messagingHeadingText",
      file: "customer-widget/tabs/support-tab.tsx",
      sectionId: "support.live_chat_widget",
    },
    {
      id: "customsAugmentation/artifactId",
      file: "customs/customs-page.tsx",
      sectionId: "international_customs.customs_artifact",
    },
    {
      id: "customsAugmentation/metafieldKeys/product",
      file: "customs/customs-page.tsx",
      sectionId: "international_customs.customs_metafields",
    },
    {
      id: "customsAugmentation/metafieldKeys/variant",
      file: "customs/customs-page.tsx",
      sectionId: "international_customs.customs_metafields",
    },
    {
      id: "discountCodePartialMatch",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "discountDistributionMethod",
      file: "customer-portal/discount-distribution-settings.tsx",
    },
    {
      id: "dynamic-coverage-transform-function",
      file: "coverage/coverage.tsx",
    },
    {
      id: "exchangeAgent/displayExchangeValueAsDiscount",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/limit",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/productRecommendations/tagExclusionRules",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeAgent/variantRecommendations/enabled",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerColor",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerCustomCss",
      file: "customer-portal/exchange-settings.tsx",
    },
    { id: "exchangeBannerFont", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "exchangeBannerFontColor",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchangeBannerShowDoneButton",
      file: "customer-portal/exchange-settings.tsx",
    },
    { id: "exchangeBannerText", file: "customer-portal/exchange-settings.tsx" },
    {
      id: "exchanges/advancedExchanges",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/allowCustomerDiscountCodes",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/allowInstant",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/applyAutomaticDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/applyOriginalOrderDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/differentPricedVariantExchanges",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/exchangeOptionsPreviewShowOriginalPrice",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeDifferentPriceVariants",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeProductSkus",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/excludeProductTags",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/hideOutOfStockVariants",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantExchangeOnly",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantExpirationDays",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/instantHoldAmount",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/recreateAutomaticDiscountsAsCodes",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/recreateExpiredDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/selection",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/shopSiteURL",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/shopSiteUseCartDiscounts",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/variantExchangeProductTags",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/variantPickerColorHexMetafield",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "exchanges/variantPickerType",
      file: "customer-portal/exchange-settings.tsx",
    },
    { id: "final-sale-subtext", file: "coverage/coverage.tsx" },
    { id: "final-sale-title-text", file: "coverage/coverage.tsx" },
    {
      id: "hideCheckbox",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.general_coverage",
    },
    {
      id: "hsa/buyButtons/showOnlyHsaPaymentMethod",
      file: "conversion/hsa/hsa-settings-page.tsx",
      sectionId: "hsa.buy_buttons",
    },
    { id: "html", file: "coverage/coverage.tsx" },
    {
      id: "ims/cycleCountVarianceAmount",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "ims/cycleCountVariancePercent",
      file: "inventory-management/general-settings.tsx",
    },
    {
      id: "ims/purchaseOrderDefaultCcEmails",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.purchase_orders",
    },
    {
      id: "ims/purchaseOrderDefaultLocationId",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.purchase_orders",
    },
    {
      id: "ims/purchaseOrderRecommendationUrgencies",
      file: "inventory-management/purchase-order-settings.tsx",
      sectionId: "inventory_purchase_orders.recommendation_urgencies",
    },
    { id: "info-modal", file: "coverage/coverage.tsx", sectionId: "display" },
    {
      id: "infoModal/cartIconEnabled",
      file: "coverage/info-modal-settings.tsx",
    },
    {
      id: "infoModal/checkoutIconEnabled",
      file: "coverage/info-modal-settings.tsx",
    },
    { id: "infoModal/customCss", file: "coverage/info-modal-settings.tsx" },
    {
      id: "infoModal/enableTopLayerModalApi",
      file: "coverage/info-modal-settings.tsx",
    },
    { id: "infoModal/headerText", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/logo", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/sideImage", file: "coverage/info-modal-settings.tsx" },
    { id: "infoModal/subheaderText", file: "coverage/info-modal-settings.tsx" },
    {
      id: "inventory/minimum_stock",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "labelExpiration/compensationMethodsToRemind",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/days",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/expirationEmails",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/flagReturnWhenReopened",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reminderEmailDays",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reminderEmails",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/reopenReturnAfterDays",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/shouldReopenReturnWhenLabelUsed",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "labelExpiration/strategy",
      file: "automation/label-expiration-card.tsx",
      sectionId: "returns.automation_label_expiration",
    },
    {
      id: "landedCost/purchaseLabelsOutsideOms",
      file: "components/lcg-outside-oms-card.tsx",
    },
    {
      id: "localization/enabled",
      file: "customer-portal/localization-settings.tsx",
    },
    {
      id: "orderTracking/carrierMappings",
      file: "order-tracking/order-tracking-settings.tsx",
      sectionId: "order_tracking_settings.carrier_mappings",
    },
    {
      id: "orderTracking/combineCrossOrderShipments",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/stalledDays",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/stalledDaysFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSaturdayFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSaturdayTransit",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSundayFulfillment",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/excludeSundayTransit",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/v2/orderExclusionRules",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/weeklyAnalyticsEmail/enabled",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "orderTracking/weeklyAnalyticsEmail/recipientEmails",
      file: "order-tracking/order-tracking-settings.tsx",
    },
    {
      id: "outboundLabels/address/internationalAddressOutreach",
      file: "general.tsx",
    },
    {
      id: "outboundLabels/carrierAccountDisabledServiceLevels",
      file: "carrier-accounts/merchant-carriers.tsx",
    },
    {
      id: "outboundLabels/defaultShipFromLocationExternalId",
      file: "general.tsx",
      sectionId: "fulfillment.ship_from_locations",
    },
    {
      id: "outboundLabels/disabledRedoServiceLevels",
      file: "carrier-accounts/redo-carriers.tsx",
    },
    {
      id: "outboundLabels/disableKeyboardOnScan",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "outboundLabels/documents/packingSlip/perParcelSlips",
      file: "printing.tsx",
      sectionId: "fulfillment.printing",
    },
    {
      id: "outboundLabels/fulfillmentPromiseDays",
      file: "fulfillment-cutoff/fulfillment-cutoff-schedule.tsx",
    },
    {
      id: "outboundLabels/scanVerify/manualQuantityEntry",
      file: "scan-to-verify-settings-drawer.tsx",
      sectionId: "fulfillment.scan_to_verify",
    },
    {
      id: "portalExcludedCollections",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "portalExcludedProductIds",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "portalExcludedProductTags",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "pos/allowPOSAdjustments",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/allowPOSManualDiscounts",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/defaultPosRestock",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "pos/externalLocationMappings",
      file: "point-of-sale/integration-locations-page.tsx",
      sectionId: "returns.pos_integration_locations",
    },
    {
      id: "pos/sendOnlyCompletionEmail",
      file: "point-of-sale/general-section.tsx",
      sectionId: "returns.pos",
    },
    {
      id: "preProtectedOrdersEnabled",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.pre_protected_orders",
    },
    {
      id: "products/hazmat/lithiumBattery/tagsInclude",
      file: "product/hazmat.tsx",
    },
    {
      id: "publicapi/couponedItemsDiscountThreshold",
      file: "coverage/coverage.tsx",
    },
    {
      id: "publicapi/coverageExcludeLocalPickup",
      file: "coverage/coverage.tsx",
    },
    { id: "publicapi/discountsAreFinalSales", file: "coverage/coverage.tsx" },
    {
      id: "redo-item-fulfillment",
      file: "coverage/coverage.tsx",
      sectionId: "redo-item-fulfillment",
    },
    {
      id: "returns/advancedProcessing/compensationEnabled",
      file: "automation/processing/advanced-processing-flows-section.tsx",
      sectionId: "returns.advanced_processing",
    },
    {
      id: "returns/advancedProcessing/restockingEnabled",
      file: "automation/processing/advanced-processing-flows-section.tsx",
      sectionId: "returns.advanced_processing",
    },
    {
      id: "returns/aiReturnReasons/predefinedCategories",
      file: "customer-portal/predefined-categories-settings.tsx",
    },
    {
      id: "returns/aiReturnReasons/usePredefinedCategories",
      file: "customer-portal/predefined-categories-settings.tsx",
    },
    {
      id: "returns/automation/addReturnTagToOriginalOrder",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/agentReviewRiskConfigs",
      file: "automation/agent-review-card.tsx",
      sectionId: "returns.automation_agent_review",
    },
    {
      id: "returns/automation/autoProcessGreenReturnTypes",
      file: "automation/processing/green-returns-section.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/autoProcessMerchantCreatedGreenReturnTypes",
      file: "automation/processing/green-returns-section.tsx",
      sectionId: "returns.automation_green_returns",
    },
    {
      id: "returns/automation/claimProcessing/exchange",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/exchangeDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refund",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/refundDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCredit",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/claimProcessing/storeCreditDelay",
      file: "automation/processing/claim-processing-section.tsx",
      sectionId: "returns.automation_claim_processing",
    },
    {
      id: "returns/automation/defaultReimburseOriginalShipping",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/dropoffAutoProcessCompensationMethods",
      file: "automation/processing/dropoff-auto-processing-section.tsx",
      sectionId: "returns.automation_dropoff_processing",
    },
    {
      id: "returns/automation/inventory/restock",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_inventory",
    },
    {
      id: "returns/automation/merchantCreatedReturns/enableMerchantReturnFlow",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedClaimsRequireShipping",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/merchantCreatedReturns/merchantCreatedReturnLabelChargeDefault",
      file: "automation/inventory-card.tsx",
      sectionId: "returns.automation_merchant_created",
    },
    {
      id: "returns/automation/returnAdjustmentArtifactId",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/automation/returnProcessing/exchange",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/exchangeDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refund",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/refundDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/requireImageForUndeclaredItems",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/reviewAfterWarehouseProcessing",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/storeCredit",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/returnProcessing/storeCreditDelay",
      file: "automation/processing/return-processing-section.tsx",
      sectionId: "returns.automation_return_processing",
    },
    {
      id: "returns/automation/shopify/addOrderNotes",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/addTrackingToShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/applyRestockingFeeToShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/archiveShopifyOrdersAfterReturn",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/closeShopifyReturnWhenProcessed",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createMultipleShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createSeparateShopifyReturnForGreenReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturns",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnsForClaimsAndWarranties",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/createShopifyReturnTypes",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/disableRefundLineItems",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/disposeShopifyReverseFulfillmentOnRestock",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEligibleCountries",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/dutyDrawbackEnabled",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/giftCardRecipient",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/refundAllReturnedItems",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/refundDutiesPaid",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/restockShopifyRefunds",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/shouldAutoProcessRedoReturnWhenShopifyReturnCloses",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/showStoreCreditOnRefundNote",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/skipEcommerceProviderRestock",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/skipExchangeRefunds",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationDays",
      file: "expire-store-credit.tsx",
    },
    {
      id: "returns/automation/shopify/storeCreditExpirationEnabled",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/shopify/syncReturnFeesToShopify",
      file: "automation/shopify-settings-card.tsx",
      sectionId: "returns.automation_shopify",
    },
    {
      id: "returns/automation/waiveRefundStoreCreditBelowAmount",
      file: "automation/general-settings-card.tsx",
      sectionId: "returns.automation_general",
    },
    {
      id: "returns/barcode/bottomDisplayOption",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/enabled",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/height",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/topDisplayOption",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/barcode/width",
      file: "shipping/sections/barcode-section.tsx",
    },
    {
      id: "returns/bulkReturns/collections",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/bulkReturns/hideQuantity",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/bundleReturnMode",
      file: "customer-portal/bundle-settings.tsx",
    },
    {
      id: "returns/coverageExcludedVariantMetafields",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.exclusions",
    },
    {
      id: "returns/disableRejectedItems",
      file: "customer-portal-builder/left-panel/settings/pages/select-items/select-items-page-customization-panel.tsx",
    },
    {
      id: "returns/exchanges/addTaxToExchangeOrders",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/enabled",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/returnValueGateway",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/applyExchangeOrderPaymentGateways/upsellGateway",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/exchangeFinancialStrategy",
      file: "exchange/exchange-financial-strategy-section.tsx",
      sectionId: "returns.exchanges_order_pricing",
    },
    {
      id: "returns/exchanges/exchangeShippingName",
      file: "exchanges/cards/exchange-shipping-card.tsx",
      sectionId: "returns.exchanges_shipping_name",
    },
    {
      id: "returns/exchanges/fulfillment/excessExchangeValue",
      file: "exchanges/cards/fulfillment-card.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillment/outOfStockAdvanced",
      file: "exchanges/cards/fulfillment-card.tsx",
      sectionId: "returns.exchanges_fulfillment",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/defaultLocationIds",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/enabled",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/fulfillmentRegions/regionMappings",
      file: "exchanges/cards/fulfillment-regions-card.tsx",
      sectionId: "returns.exchanges_fulfillment_regions",
    },
    {
      id: "returns/exchanges/orderName/duplicateOrderNumberFormat",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/prefix",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/reuseOrderName",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderName/shouldStripHash",
      file: "exchanges/cards/order-name-input.tsx",
    },
    {
      id: "returns/exchanges/orderNotes/addNoteToOriginalOrders",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/disabled",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/includeDate",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orderNotes/includeExistingNote",
      file: "exchanges/cards/exchange-notes-card.tsx",
      sectionId: "returns.exchanges_order_notes",
    },
    {
      id: "returns/exchanges/orders/addAdditionalExchangeTags",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItem",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/applyFeesAsLineItemName",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/createTrigger",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/exchangeOrderCreationArtifactId",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/labelWaitForInvoice",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/nonZeroValueExchangeStrategy",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/separateQuantityForExchangeProducts",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/shopifyExchangeOrderStrategy",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    {
      id: "returns/exchanges/orders/shouldRemoveHoldTagWhenRelease",
      file: "exchanges/cards/order-card.tsx",
      sectionId: "returns.exchanges_orders",
    },
    { id: "returns/finalSaleReturns/enabled", file: "coverage/coverage.tsx" },
    {
      id: "returns/giftReceipts/enabled",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/giftReceipts/missingBuyerInfoDescription",
      file: "returns-ui/gift-receipts-card.tsx",
      sectionId: "returns.ui_gift_receipts",
    },
    {
      id: "returns/itemDisposition/enabled",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/gradeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/itemDisposition/outcomeOptions",
      file: "returns-ui/item-disposition-card.tsx",
      sectionId: "returns.ui_item_disposition",
    },
    {
      id: "returns/permissions/allowEditFeesAndBonuses",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditGreenReturns",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowEditReturn",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowExchange",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowRefund",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/permissions/allowStoreCredit",
      file: "permissions/permissions.tsx",
      sectionId: "returns.permissions",
    },
    {
      id: "returns/processing/allowRestockBeforeProcess",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/checkForTryNowTags",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/giftCardOrderProductId",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/hideGiftCardBranding",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/riseTriggerUrl",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/processing/shopAgainAction",
      file: "processing.tsx",
      sectionId: "returns.processing",
    },
    {
      id: "returns/redoAssistedCustoms/customsDescriptionOptOut",
      file: "international/redo-assisted-customs-card.tsx",
      sectionId: "international_returns.redo_assisted_customs",
    },
    {
      id: "returns/redoAssistedCustoms/hsCodeOptOut",
      file: "international/redo-assisted-customs-card.tsx",
      sectionId: "international_returns.redo_assisted_customs",
    },
    {
      id: "returns/returnEditing/allowCustomerCancelReturn",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnEditing/allowCustomerEditExchangeAddress",
      file: "returns-ui/return-editing-card.tsx",
      sectionId: "returns.ui_return_editing",
    },
    {
      id: "returns/returnsCoverageExcludedSkus",
      file: "coverage/coverage.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/australiaPostPrinterlessText",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/customerLabelUpchargeFee",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/customInStoreLocations",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromCredit",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromExchange",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/deductLabelFromRefund",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/dontChargeCustomerLabelUpchargeWhenOnlyOption",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/dropoffs",
      file: "shipping/sections/dropoff-providers-section.tsx",
    },
    {
      id: "returns/shipping/excludeCustomerLabelFeeForExchanges",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/formLabelInstructions",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/ignoreTeamCarrierOverrideInMerchantDash",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/includeExchangeItemsOnPackingSlip",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/inStoreDropOffPackingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/inStoreLocations",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/labelCustomText",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/labelIncludeReturnType",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/manualLabelInstructions",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/manualLabelPackingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/merchantMaxLabelPrice",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/onlyCombineLabelsFromSameFulfillment",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/packingInstructions",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/packingSlipEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmount",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/pickupMaxCoveredAmountEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsEnabled",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureForTagsTags",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/requireReturnShippingSignatureThreshold",
      file: "shipping/sections/shipping-options-section.tsx",
    },
    {
      id: "returns/shipping/returnInStoreEnabled",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/returnInStoreRadiusMiles",
      file: "shipping/sections/return-locations-section.tsx",
    },
    {
      id: "returns/shipping/skuGroupingCsvFileUrl",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/skuGroupingEnabled",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shipping/verifyAddressForLabel",
      file: "flows/location-settings.tsx",
    },
    {
      id: "returns/shopifyCustomsMetafields/descriptionKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/manufacturerKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/materialKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantDescriptionKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantManufacturerKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/shopifyCustomsMetafields/variantMaterialKey",
      file: "international/international-sections.tsx",
      sectionId: "international_returns.customs_metafields",
    },
    {
      id: "returns/ui/aiReviewDefaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/defaultCollapsed",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/exposeExternalId",
      file: "returns-ui/external-ra-number-card.tsx",
      sectionId: "returns.ui_external_ra_number",
    },
    {
      id: "returns/ui/lineItemDetailOptions",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/productMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/ui/variantMetafieldDisplays",
      file: "returns-ui/return-details-card.tsx",
      sectionId: "returns.ui_return_details",
    },
    {
      id: "returns/useShopifyNativeBundles",
      file: "customer-portal/bundle-settings.tsx",
    },
    {
      id: "returns/warehouse/gradeMappings",
      file: "managed-returns/returns-centers-index.tsx",
      sectionId: "returns.warehouse_grade_actions",
    },
    {
      id: "returns/withdrawals/enabled",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/enableMerchantWithdrawalSubmittedEmail",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/enablethirdPartyFulfillmentCancellationEmail",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/excludedCollections",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/excludedMetafields",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/excludedProductTags",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_exclusions",
    },
    {
      id: "returns/withdrawals/hourDelayForAutoCancellation",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/lateWithdrawalNoticeText",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/merchantEmailsForNotifications",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "returns/withdrawals/preventAutoCancellingUnfulfilledOrder",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/shippingRefundFixedAmount",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/shippingRefundMode",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/tagsToAddToAutoCancelledOrders",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_general",
    },
    {
      id: "returns/withdrawals/tagsToBlockAutoCancellation",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_auto_cancellation",
    },
    {
      id: "returns/withdrawals/thirdPartyFulfillmentCancellationEmailList",
      file: "withdrawals/withdrawals-settings.tsx",
      sectionId: "returns.withdrawals_notifications",
    },
    {
      id: "shopifyExtension/checkoutUICustomizations/spacing",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopifyExtension/checkoutUICustomizations/subtextSize",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopifyExtension/checkoutUICustomizations/titleTextSize",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopifyExtension/coverageExcludePickup",
      file: "coverage/coverage.tsx",
      sectionId: "coverage.general_coverage",
    },
    {
      id: "shopifyExtension/deleteCartProperties",
      file: "coverage/coverage.tsx",
    },
    {
      id: "shopifyExtension/displayIcon",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerInsertBeforeBody",
      file: "customer-portal/exchange-settings.tsx",
    },
    {
      id: "shopifyExtension/exchangeBannerPositionBottom",
      file: "customer-portal/exchange-settings.tsx",
    },
    { id: "shopifyExtension/icon", file: "coverage/cart-item-settings.tsx" },
    {
      id: "shopifyExtension/iconBackgroundColor",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "shopifyExtension/iconColor",
      file: "coverage/cart-item-settings.tsx",
    },
    { id: "shopifyExtension/logo", file: "coverage/cart-item-settings.tsx" },
    {
      id: "shopifyExtension/redoProductImage",
      file: "coverage/cart-item-settings.tsx",
    },
    {
      id: "support/csat/abTestEnabled",
      file: "customer-satisfaction/panels/ab-test-settings.tsx",
    },
    {
      id: "support/csat/abTestVariants",
      file: "customer-satisfaction/panels/ab-test-settings.tsx",
    },
    {
      id: "support/csat/allowedInboxEmails",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/allowRemarks",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/emailTemplateId",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/enabled",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/headerImage",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/sampleRate",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/surveyMessage",
      file: "customer-satisfaction/panels/template-settings.tsx",
    },
    {
      id: "support/csat/surveyMethods",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    {
      id: "support/csat/surveySendTime",
      file: "customer-satisfaction/panels/general-settings.tsx",
    },
    { id: "support/unassignOpenTicketsAtShiftEnd", file: "ticket-rules.tsx" },
    {
      id: "warranties/allowQuantitySelect",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/askShopperForPricePaid",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/cantFindItemButtonEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/mailingListSignUpEnabled",
      file: "customer-portal-builder/left-panel/settings/pages/contact-information/contact-information-page-customization-panel.tsx",
    },
    {
      id: "warranties/maxQuantitySelect",
      file: "customer-portal-builder/left-panel/settings/pages/registration-catalog/registration-catalog-page-customization-panel.tsx",
    },
    {
      id: "warranties/purchaseChannelRegistrationCollection",
      file: "registration-settings.tsx",
      sectionId: "warranty_registration.registration_collections",
    },
    {
      id: "warranties/purchaseChannels",
      file: "registration-settings.tsx",
      sectionId: "warranty_registration.purchase_channels",
    },
    {
      id: "warranties/registrationRewardDiscountId",
      file: "registration-rewards.tsx",
      sectionId: "warranty_registration_rewards.discount",
    },
    {
      id: "warranties/showOtherOption",
      file: "customer-portal-builder/left-panel/settings/pages/purchase-channel/purchase-channel-page-customization-panel.tsx",
    },
  ],
};
